<template>
  <rest-list-action
    icon="el-icon-edit-outline"
    :title="$t(title ? title : 'RestList_Action_Update')"
    :route="route"
    data-qa="update-action-button"
  />
</template>

<script>
import RestListAction from '@/common/components/rest/RestListAction'

export default {
  name: 'RestListActionUpdate',

  components: { RestListAction },

  props: {
    route: {
      type: Object,
      required: true
    },
    title: {
      type: String,
      required: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/common/components/rest/RestListActionUpdate.vue